import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {LogsTypeTraductionKey} from "../../../logsType";
import Badge from "../../../../../../components/Badge";
import {grey300} from "../../../../../../assets/jss/main";
import {WMSContext} from "../../../../context/WMSContext";
import moment from "moment/moment";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";

LogContainerItem.propTypes = {
    item: PropTypes.object.isRequired
};

function LogContainerItem({item}) {
    const {isMobile} = useContext(WMSContext);

    // TODO: Pas de logs générés à la fin du picking pour avoir le nombre d'items dans le chariot. Même chose à la fin du sorting. Il en faudrait probablement.

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container direction={isMobile ? "column" : "row"} gap={"8px"} alignItems={"center"}>
                    <Badge color={"default"} rounded>
                        <span style={{fontSize: '1rem'}}>
                            {LogsTypeTraductionKey[item.event]
                                ? <FormattedMessage id={LogsTypeTraductionKey[item.event]}/>
                                : item.event
                            }
                        </span>
                    </Badge>
                    <p style={{fontSize: '0.8rem'}}>
                        {item.member?.user?.fullName ?? null}
                    </p>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300}}>
                <Grid container direction={"column"} gap={"8px"}>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.container.member.label"}/>
                        <Badge>{item.data.member?.user?.fullName ?? 'N/A'}</Badge>
                    </Grid>
                    <Grid container alignItems={"center"} gap={"8px"} flexWrap={"wrap"}>
                        <FormattedMessage id={"wms.logs.container.shippingMethod.label"}/>
                        {item.data.shippingMethods?.length > 0
                            ? item.data.shippingMethods.map(sm => <Badge key={sm.id}>{sm.name}</Badge>)
                            : <Badge>{item.data.shippingMethod?.name ?? 'N/A'}</Badge>
                        }
                    </Grid>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.container.shipmentCount.label"}/>
                        <Badge>{item.data.shipments?.length ?? 0}</Badge>
                    </Grid>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.container.itemCount.label"}/>
                        <Badge>{item.data.wmsItems?.length ?? 0}</Badge>
                    </Grid>
                    {item.data.maxCapacity && (
                        <Grid container>
                            <Badge color={"error"} rounded isBold>
                                <FormattedMessage id={"wms.logs.container.maxCapacity.label"}/>
                            </Badge>
                        </Grid>
                    )}
                    {item.data.computerId && (
                        <Grid container alignItems={"center"} gap={"8px"}>
                            <FormattedMessage id={"wms.logs.container.computerId.label"}/>
                            <Badge>{item.data.computerId}</Badge>
                        </Grid>
                    )}
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.updatedAt.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {moment.utc(item.createdAt).local().format("DD/MM/YYYY HH:mm:ss")}
                        </Badge>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default LogContainerItem;